import React from "react";
import { motion } from "framer-motion";
import { pathVariants4 } from "../paths/pathVariants";

export const Pen = () => {
  return (
    <div className="svg-right">
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 540.43 450.88">
        <g style={{ isolation: "isolate" }}>
          <g id="Layer_2" data-name="Layer 2">
            <g id="objects">
              <motion.polyline
                variants={pathVariants4}
                initial="hidden"
                animate="visible"
                points="10.94 400.1 0.5 400.1 0.5 397.41 121.51 397.41"
                fill="none"
                stroke="#fff"
                stroke-miterlimit="10"
                fillRule="evenodd"
              />
              <motion.polyline
                points="121.51 430.54 0.5 430.54 0.5 427.85 10.94 427.85"
                fill="none"
                stroke="#fff"
                stroke-miterlimit="10"
                fillRule="evenodd"
              />
              <motion.path
                variants={pathVariants4}
                initial="hidden"
                animate="visible"
                d="M55.86,397.41h65.65c9.25,0,9.25,33.12,0,33.12H55.86C63.54,424.91,63,404.36,55.86,397.41Z"
                fill="none"
                stroke="#fff"
                stroke-miterlimit="10"
                fillRule="evenodd"
              />
              <motion.path
                variants={pathVariants4}
                initial="hidden"
                animate="visible"
                d="M60,397.41H.5v2.69H3l50.87.61a23.56,23.56,0,0,1,1,25"
                fill="none"
                stroke="#fff"
                stroke-miterlimit="10"
                fillRule="evenodd"
              />
              <motion.path
                variants={pathVariants4}
                initial="hidden"
                animate="visible"
                d="M55.91,423.71q-1,2-2,4l-43,.14H.5v2.68H59.8"
                fill="none"
                stroke="#fff"
                stroke-miterlimit="10"
                fillRule="evenodd"
              />
              <motion.polyline
                variants={pathVariants4}
                initial="hidden"
                animate="visible"
                points="120.68 366.97 131.12 366.97 131.12 364.29 10.11 364.29"
                fill="none"
                stroke="#fff"
                stroke-miterlimit="10"
                fillRule="evenodd"
              />
              <motion.polyline
                variants={pathVariants4}
                initial="hidden"
                animate="visible"
                points="10.11 397.41 131.12 397.41 131.12 394.73 120.68 394.73"
                fill="none"
                stroke="#fff"
                stroke-miterlimit="10"
                fillRule="evenodd"
              />
              <motion.path
                variants={pathVariants4}
                initial="hidden"
                animate="visible"
                d="M129.56,394.73a34.55,34.55,0,0,1-3.31-15A35.24,35.24,0,0,1,128.58,367"
                fill="none"
                stroke="#fff"
                stroke-miterlimit="10"
                fillRule="evenodd"
              />
              <motion.path
                variants={pathVariants4}
                initial="hidden"
                animate="visible"
                d="M75.76,364.29H10.11c-9.25,0-9.25,33.12,0,33.12H75.76C68.08,391.78,68.6,371.23,75.76,364.29Z"
                fill="none"
                stroke="#fff"
                stroke-miterlimit="10"
                fillRule="evenodd"
              />
              <motion.path
                variants={pathVariants4}
                initial="hidden"
                animate="visible"
                d="M71.59,364.29h59.53V367h-2.54l-51.67-.26"
                fill="none"
                stroke="#fff"
                stroke-miterlimit="10"
                fillRule="evenodd"
              />
              <motion.path
                variants={pathVariants4}
                initial="hidden"
                animate="visible"
                d="M76.91,366.71a26.41,26.41,0,0,0-4,17,25.62,25.62,0,0,0,4,11l52.65,0h1.56v2.68H71.82"
                fill="none"
                stroke="#fff"
                stroke-miterlimit="10"
                fillRule="evenodd"
              />
              <motion.path
                variants={pathVariants4}
                initial="hidden"
                animate="visible"
                d="M38.13,340H21v-1.87h86.06c5.06,0,9.2,3.21,9.2,7.12v11.89c0,3.92-4.14,7.13-9.2,7.13H21v-1.87H38.13"
                fill="none"
                stroke="#fff"
                stroke-miterlimit="10"
                fillRule="evenodd"
              />
              <motion.polyline
                variants={pathVariants4}
                initial="hidden"
                animate="visible"
                points="38.13 340.02 21 340.02 21 338.15 72.25 338.15"
                fill="none"
                stroke="#fff"
                stroke-miterlimit="10"
                fillRule="evenodd"
              />
              <motion.polyline
                variants={pathVariants4}
                initial="hidden"
                animate="visible"
                points="72.25 364.29 21 364.29 21 362.42 38.13 362.42"
                fill="none"
                stroke="#fff"
                stroke-miterlimit="10"
                fillRule="evenodd"
              />
              <motion.path
                variants={pathVariants4}
                initial="hidden"
                animate="visible"
                d="M22.63,362.42h84.69c3.31,0,6.78-2.08,6.78-5.26V345.27c0-3.17-3.47-5.25-6.78-5.25H22.63a40.58,40.58,0,0,1,1.54,11.2A40.58,40.58,0,0,1,22.63,362.42Z"
                fill="none"
                stroke="#fff"
                stroke-miterlimit="10"
                fillRule="evenodd"
              />
              <motion.path
                variants={pathVariants4}
                initial="hidden"
                animate="visible"
                d="M73.63,362.42a41.5,41.5,0,0,0,0-22.4h-51a40.58,40.58,0,0,1,1.54,11.2,40.58,40.58,0,0,1-1.54,11.2Z"
                fill="none"
                stroke="#fff"
                stroke-miterlimit="10"
                fillRule="evenodd"
              />
              <motion.path
                variants={pathVariants4}
                initial="hidden"
                animate="visible"
                d="M167.15,189.51l8.36-1.39s25.82,2.62,37.07,7.75,12.5,10.75,12.5,10.75c11.68-6.68,40.16-19.67,59.5-16.5l10.28,1.68"
                fill="none"
                stroke="#fff"
                stroke-miterlimit="10"
                fillRule="evenodd"
              />
              <motion.path
                variants={pathVariants4}
                initial="hidden"
                animate="visible"
                d="M329.91,205.71a66.35,66.35,0,0,0-28,12"
                fill="none"
                stroke="#fff"
                stroke-miterlimit="10"
                fillRule="evenodd"
              />
              <motion.path
                variants={pathVariants4}
                initial="hidden"
                animate="visible"
                d="M434.88,217c.36-2.39-23.51-8.94-45-12.31-2.8-.44-5.19-.77-7-1"
                fill="none"
                stroke="#fff"
                stroke-miterlimit="10"
                fillRule="evenodd"
              />
              <motion.path
                variants={pathVariants4}
                initial="hidden"
                animate="visible"
                d="M366.88,199.77h0"
                fill="none"
                stroke="#fff"
                stroke-miterlimit="10"
                fillRule="evenodd"
              />
              <motion.path
                variants={pathVariants4}
                initial="hidden"
                animate="visible"
                d="M313.91,236.71a22,22,0,0,0,1-7c-.1-3.67-1.11-3.93-1-7a16.4,16.4,0,0,1,4-10,14.52,14.52,0,0,1,2.47-2.19c9.74-7.14,23.21-7.73,25.53-7.81,1.57-.06,2.93,0,4,0"
                fill="none"
                stroke="#fff"
                stroke-miterlimit="10"
                fillRule="evenodd"
              />
              <motion.path
                variants={pathVariants4}
                initial="hidden"
                animate="visible"
                d="M387.91,204.71a6.8,6.8,0,0,1,2,3,8,8,0,0,1,0,4c-.59,2.29-5.69,13.2-19.07,18-15.21,5.49-34.07.59-35.5-6.13-.33-1.51,2-5.66,6.57-13.9,1.64-3,3-5.37,4-7"
                fill="none"
                stroke="#fff"
                stroke-miterlimit="10"
                fillRule="evenodd"
              />
              <motion.path
                variants={pathVariants4}
                initial="hidden"
                animate="visible"
                d="M350.91,190.71c0,.48,0,1.17,0,2a46.61,46.61,0,0,1-1,8c-1.73,7.64-11.53,17.42-9.46,23.24,1.79,5,11.93,5.55,13.73,5.67,16.83,1.11,31.32-18.35,31.69-21.1.45-3.27-3.81-4-6.23-10.19a25.86,25.86,0,0,1-1.73-9.62"
                fill="none"
                stroke="#fff"
                stroke-miterlimit="10"
                fillRule="evenodd"
              />
              <motion.polyline
                variants={pathVariants4}
                initial="hidden"
                animate="visible"
                points="165.69 190.32 167.15 189.5 223.76 211.27 294.86 191.8 296.19 192.82"
                fill="none"
                stroke="#fff"
                stroke-miterlimit="10"
                fillRule="evenodd"
              />
              <motion.path
                variants={pathVariants4}
                initial="hidden"
                animate="visible"
                d="M184.91,265.71q1.72,9.56,3.79,19.43c.65,3.09,1.32,6.16,2,9.19l55.56,17.54,11.57-2.62-23.61-99.44-11,3.06-57.56-22.55q5.12,21.19,10.22,42.39"
                fill="none"
                stroke="#fff"
                stroke-miterlimit="10"
                fillRule="evenodd"
              />
              <motion.path
                variants={pathVariants4}
                initial="hidden"
                animate="visible"
                d="M314.91,271.71c1.12,3.17,2.21,7.57,3.23,11.19,1.28,4.55,2.27,8.87,3.05,12.92-3,0-75,16-75,16l-23-99,73-20,9.72,40.89"
                fill="none"
                stroke="#fff"
                stroke-miterlimit="10"
                fillRule="evenodd"
              />
              <motion.path
                variants={pathVariants4}
                initial="hidden"
                animate="visible"
                d="M229.91,374.71c-2-3-14.4,6.52-19,7-10.48,1.08-13.46-3-32.46-4.39-8.84-.65-14.23,0-19.92,2.24a30.51,30.51,0,0,0-9.33,6.26c-9.25,8.5-8,24.75-4.75,36.5s9.25,12.5,20.5,10.5,24.08-9.5,35.25-9.5,13.75,2.25,21.75.75c5.2-1,7.55-.15,8.48-1,1.13-1.07.61-2.94.52-3.46C230.14,415,236.68,384.86,229.91,374.71Z"
                fill="none"
                stroke="#fff"
                stroke-miterlimit="10"
                fillRule="evenodd"
              />
              <motion.path
                variants={pathVariants4}
                initial="hidden"
                animate="visible"
                d="M185,377.52c-2.48-.15-4.72-.23-6.59-.2-14.25.25-20,0-29.25,8.5s-8,24.75-4.75,36.5c2.94,10.64,8.13,12.26,17.43,11-13.52-13.83-19.12-41.33.84-51.83C167.75,378.83,177.18,377.86,185,377.52Z"
                fill="none"
                stroke="#fff"
                stroke-miterlimit="10"
                fillRule="evenodd"
              />
              <motion.path
                variants={pathVariants4}
                initial="hidden"
                animate="visible"
                d="M222.72,389c-5.86,1.76-50.42-3.24-55,5-2.5,4.5,0,22,1.5,27.5s8,3.25,11.25,2.25,13.5-4.5,24.5-3.5,19.43,5.56,21.13-1.09S222.17,389.05,222.72,389Z"
                fill="none"
                stroke="#fff"
                stroke-miterlimit="10"
                fillRule="evenodd"
              />
              <motion.path
                variants={pathVariants4}
                initial="hidden"
                animate="visible"
                d="M392.45,391.82c8.25,1,15.75,2,13.25,13.25s-15.75,42.75-23.5,44.5c-17.82,4-37.94-8.15-43.5-12-.2-.13-1.39-1-3.11-2.14-4.9-3.35-8.95-6-11.68-7.72"
                fill="none"
                stroke="#fff"
                stroke-miterlimit="10"
                fillRule="evenodd"
              />
              <motion.path
                variants={pathVariants4}
                initial="hidden"
                animate="visible"
                d="M363.29,397c7.9,1,11.91,1.25,10,6-2.89,7-9.4,22.73-10.86,25a5.33,5.33,0,0,1-5,2.5l-36.49-17.71"
                fill="none"
                stroke="#fff"
                stroke-miterlimit="10"
                fillRule="evenodd"
              />
              <motion.path
                variants={pathVariants4}
                initial="hidden"
                animate="visible"
                d="M290.91,361.71c-9-4.29-22.43-10.6-39-18-15.31-6.84-21-9.14-24.22-10.39-26.5-10.39-39.76-15.59-50.51-12.06-12.7,4.18-23,16.93-23.73,28.92-.15,2.51-.56,10.71,5.1,16.81a18.48,18.48,0,0,0,6.14,4.33"
                fill="none"
                stroke="#fff"
                stroke-miterlimit="10"
                fillRule="evenodd"
              />
              <motion.path
                variants={pathVariants4}
                initial="hidden"
                animate="visible"
                d="M160.34,350.86c-1.58-10.46,7.32-22.23,5.57-23.15s-11.77,9.47-12.46,22.47c-.11,1.92-.59,10.64,5.1,16.81,1.54,1.67,3.11,2.57,6.14,4.33a74,74,0,0,0,14.22,6.39"
                fill="none"
                stroke="#fff"
                stroke-miterlimit="10"
                fillRule="evenodd"
                style={{ mixBlendMode: "multiply" }}
              />
              <motion.path
                variants={pathVariants4}
                initial="hidden"
                animate="visible"
                d="M301.91,419.71l10,8c3.77,3.73,6.46,3.82,7.74,3.64,3.07-.43,5.51-4.51,10.26-12.64.64-1.11,5.51-9.46,7-12"
                fill="none"
                stroke="#fff"
                stroke-miterlimit="10"
                fillRule="evenodd"
              />
              <motion.path
                variants={pathVariants4}
                initial="hidden"
                animate="visible"
                d="M282.91,101.71a61.41,61.41,0,0,1,2-14,63.74,63.74,0,0,1,14-26"
                fill="none"
                stroke="#fff"
                stroke-miterlimit="10"
                fillRule="evenodd"
              />
              <motion.path
                variants={pathVariants4}
                initial="hidden"
                animate="visible"
                d="M434.37,109.81s13.27-7.88,17.71,5.28c.14.43.28.87.4,1.34,4,15-6.62,30.91-16.78,35.77S421.13,154,421.13,154c-.08.54-.18,1.49-.47,2.76-3.72,16.56-23.76,24.88-32.65,28.59-32.76,13.66-71.78-1.26-80.1-4.61a38.41,38.41,0,0,1-13-10c-8.69-10.38-9-22.28-9-26"
                fill="none"
                stroke="#fff"
                stroke-miterlimit="10"
                fillRule="evenodd"
              />
              <motion.path
                variants={pathVariants4}
                initial="hidden"
                animate="visible"
                d="M411.63,140.5s2.37-16.43,4.13-32.11,1.44-39.85-4.52-43.27-18.11-5.74-40.63-4.64-58.78,8.7-58.78,8.7"
                fill="none"
                stroke="#fff"
                stroke-miterlimit="10"
                fillRule="evenodd"
                style={{ mixBlendMode: "multiply" }}
              />
              <motion.path
                variants={pathVariants4}
                initial="hidden"
                animate="visible"
                d="M311.83,69.18c-28.58-7.17-20.4-47.84-20.75-49.9L292.4,27a80.4,80.4,0,0,1,13.36-17c7.95-7.4,11.48-7.84,11.48-7.84S312.61,13,312.72,12.44s6-5.63,15.56-9.5,20.54-2,19.54-2-11.7,10.59-11.7,10.59a22.43,22.43,0,0,1,12.37-5.63c7.28-.66,13,.78,12,.67S355,9.24,354,14.65,362.73,22,374.65,24s28.92.88,44.16,7.29S437.36,49.2,437.36,49.2s5.93.4,13,9.89-5.54,48.61-5.54,48.61c-4.41-.83-10,1.63-10.45,2.11-7.94,7.8-13.24,36.78-14.79,35.55a76.89,76.89,0,0,0-7.95-4.86"
                fill="none"
                stroke="#fff"
                stroke-miterlimit="10"
                fillRule="evenodd"
              />
              <motion.path
                variants={pathVariants4}
                initial="hidden"
                animate="visible"
                d="M311.83,69.18c-20.9-5.24-22.14-28.4-21.44-41.28A38,38,0,0,0,292.94,38c4.63,11.81,15.34,22.74,15,22s-3.18-1.67-1.26-11.82,5.23-14.35,4.46-12.8.77,10.71,3.42,18.44,4.75,8.5,4.75,8.5-.5-4.55,4.09-12.81,15.34-15.23,14.13-14.24-4.86,9-5.19,14.35.55,7.29.55,7.29,2.87-4.42,16-13S371.76,35,369.77,35s-5.19,1.43-9.82,9.49-2.21,9.06-2.21,9.06a110.55,110.55,0,0,1,21.2-10.16c13-4.75,25.39-4.31,24.28-4.53s-12.8,6-15.34,8.83-2.76,4.53-2.76,4.53S392,49.82,406.54,47s24.95,2,23.4,2-16.12,7.73-16.12,7.73,10.16,2.43,15.68,6a29.32,29.32,0,0,1,8.61,8.83L429.48,69l-2.57.74a57.63,57.63,0,0,1,5,11,59.91,59.91,0,0,1,2,29"
                fill="none"
                stroke="#fff"
                stroke-miterlimit="10"
                fillRule="evenodd"
              />
              <motion.path
                variants={pathVariants4}
                initial="hidden"
                animate="visible"
                d="M326.91,116.71a10.36,10.36,0,0,1,2-5,10.16,10.16,0,0,1,2-2"
                fill="none"
                stroke="#fff"
                stroke-miterlimit="10"
              />
              <motion.path
                variants={pathVariants4}
                initial="hidden"
                animate="visible"
                d="M375.91,142.71c-.77,1.08-9.43,12.92-24.84,12.83-15.95-.09-24.55-12.88-25.16-13.83"
                fill="none"
                stroke="#fff"
                stroke-miterlimit="10"
              />
              <motion.path
                variants={pathVariants4}
                initial="hidden"
                animate="visible"
                d="M378.91,120.71a27.51,27.51,0,0,1,1,9,27.8,27.8,0,0,1-3,11"
                fill="none"
                stroke="#fff"
                stroke-miterlimit="10"
              />
              <motion.path
                variants={pathVariants4}
                initial="hidden"
                animate="visible"
                d="M373.91,105.71l-6-5"
                fill="none"
                stroke="#fff"
                stroke-miterlimit="10"
                fillRule="evenodd"
              />
              <motion.path
                variants={pathVariants4}
                initial="hidden"
                animate="visible"
                d="M325.91,107.71a14.16,14.16,0,0,0,13.73.21c3.61-1.74,12.42-2.33,34.27,1.79"
                fill="none"
                stroke="#fff"
                stroke-miterlimit="10"
                fillRule="evenodd"
              />
              <motion.path
                variants={pathVariants4}
                initial="hidden"
                animate="visible"
                d="M285.91,141.71a28.89,28.89,0,0,1,0-9c.65-4.09,1.84-5.71,2.24-8.34a15,15,0,0,0,.12-2.68c0-3.14.05-6-1.36-9a13.53,13.53,0,0,0-2-3"
                fill="none"
                stroke="#fff"
                stroke-miterlimit="10"
              />
              <motion.path
                variants={pathVariants4}
                initial="hidden"
                animate="visible"
                d="M306.91,145.71a10.58,10.58,0,0,1-21-1"
                fill="none"
                stroke="#fff"
                stroke-miterlimit="10"
              />
              <motion.path
                variants={pathVariants4}
                initial="hidden"
                animate="visible"
                d="M285.33,101.41c1.51-1,12.32-8.32,21.58-3.7a14.55,14.55,0,0,1,3,2"
                fill="none"
                stroke="#fff"
                stroke-miterlimit="10"
                fillRule="evenodd"
              />
              <motion.path
                variants={pathVariants4}
                initial="hidden"
                animate="visible"
                d="M303.91,109.71c-7.43-3.71-11.57-3.24-14-2-1.4.71-3.28,2.19-6,2-1.41-.1-3.78-.66-4-2a2.53,2.53,0,0,1,1-2"
                fill="none"
                stroke="#fff"
                stroke-miterlimit="10"
                fillRule="evenodd"
              />
              <motion.path
                variants={pathVariants4}
                initial="hidden"
                animate="visible"
                d="M310.91,103.71c1,2.27,1,5.68-.63,6.65a2.83,2.83,0,0,1-2.19.16"
                fill="none"
                stroke="#fff"
                stroke-miterlimit="10"
                fillRule="evenodd"
              />
              <motion.path
                variants={pathVariants4}
                initial="hidden"
                animate="visible"
                d="M309.91,134.71q-.39-6.66-.87-13.46-.54-7.64-1.18-15.09s1.76-2.36,7.39-2.3,7.3,1.75,7.3,1.75-1,31.13,3.2,35.55,45.7,3.53,49.9,1.77,3.09-39.09,3.09-39.09l51.33,11.82,2.76-4.09c-2.21,0-55.42-14.68-57.18-15.12-7-1.75-103.52,4-106,8.39-.76,9.87,2.24,33.87,6.24,38.87,2.25,2.81,25.92,1.65,28,1m-2-3c-7.43-.23-15.59,2.55-22.29-.67a4.61,4.61,0,0,1-2.32-2.73c-3.39-11.6-3-21.17-4.45-31.76l28.63-3.38,1.76,1q1.83,16.78,3.67,33.55M373,139.37c-2.51,2.76-44,.31-44.31.12-1.79-1.19-3.29-32.72-1.74-37.48.49-1.52,32-1.5,42.07-1.33,1.61,0,3.89-.4,4.26,1.17C374.75,108,374.33,137.93,373,139.37Z"
                fill="none"
                stroke="#fff"
                stroke-miterlimit="10"
                fillRule="evenodd"
              />
              <motion.path
                variants={pathVariants4}
                initial="hidden"
                animate="visible"
                d="M316.12,129.11c1.65-4.63.55-5.74.55-5.74-.33,1.44-.77,4.86-6.29,10.71s-8.39,5.67-8.38,8c0,2,9.2,6.36,10.85,6.69s6.08-.63,6-2.24c0-.91-4.44-1.71-7.64-2.69-2.4-.73-4.12-1.56-2.74-2.6"
                fill="none"
                stroke="#fff"
                stroke-miterlimit="10"
                fillRule="evenodd"
              />
              <motion.path
                variants={pathVariants4}
                initial="hidden"
                animate="visible"
                d="M349.26,119.73c2.44,0,4.59,2.28,4.81,5.08s-1.58,5.08-4,5.08-4.59-2.28-4.81-5.08S346.82,119.73,349.26,119.73Z"
                fill="none"
                stroke="#fff"
                stroke-miterlimit="10"
                fillRule="evenodd"
              />
              <motion.path
                variants={pathVariants4}
                initial="hidden"
                animate="visible"
                d="M297,122.16c2.44,0,4.57,2.27,4.77,5.08s-1.62,5.08-4.06,5.08-4.57-2.28-4.77-5.08S294.57,122.16,297,122.16Z"
                fill="none"
                stroke="#fff"
                stroke-miterlimit="10"
                fillRule="evenodd"
              />
              <motion.path
                variants={pathVariants4}
                initial="hidden"
                animate="visible"
                d="M231.91,379.71a764.09,764.09,0,0,0,80.28-25.38c35.83-13.59,62.58-26.95,78.75-15.75a37.26,37.26,0,0,1,13.9,18.78,32.14,32.14,0,0,1-.15,16c-2.5,10.49-14.5,15-14.5,15a540.56,540.56,0,0,1-102.63,35.14c-16,3.73-31.34,6.53-45.87,8.62"
                fill="none"
                stroke="#fff"
                stroke-miterlimit="10"
                fillRule="evenodd"
              />
              <motion.path
                variants={pathVariants4}
                initial="hidden"
                animate="visible"
                d="M180.42,233.31c4.71.15,8.74,7.33,2.33,8.5s-8.63,1.07-11.14-1.43c-1.48-1.48-1.29-3.72-1-5.33C171,232.67,175.85,233.17,180.42,233.31Z"
                fill="none"
                stroke="#fff"
                stroke-miterlimit="10"
                fillRule="evenodd"
              />
              <motion.path
                variants={pathVariants4}
                initial="hidden"
                animate="visible"
                d="M183,234.08c3.31,1.91,5,6.79-.23,7.73-6,1.11-8.35,1.07-10.69-1"
                fill="none"
                stroke="#fff"
                stroke-miterlimit="10"
                fillRule="evenodd"
              />
              <motion.path
                variants={pathVariants4}
                initial="hidden"
                animate="visible"
                d="M447.53,118.94c2.41,4.82-.33,14-4.71,20.58s-9.08,9.08-12.59,7.55-3.8-4.09-2.17-7.35,4.8-1.19,5.13-4.47-.88-1.75-1.53-5.36.22-4.93,2.19-8.54C436.56,116.38,444.7,113.28,447.53,118.94Z"
                fill="none"
                stroke="#fff"
                stroke-miterlimit="10"
                fillRule="evenodd"
              />
              <motion.path
                variants={pathVariants4}
                initial="hidden"
                animate="visible"
                d="M317,164.15c15.26,1.52,41.86,2.47,57.2-5C369.42,167.53,318.33,168,317,164.15Z"
                fill="none"
                stroke="#fff"
                stroke-miterlimit="10"
                fillRule="evenodd"
              />
              <motion.path
                variants={pathVariants4}
                initial="hidden"
                animate="visible"
                d="M405.7,405.07c.47-2.12,1.22-5.85-.83-8.73-3.08-4.36-10.37-3.79-12-3.63a64.51,64.51,0,0,1-23,55.86c5.3,1.08,9.86,1.56,12.33,1C390,447.82,403.2,416.32,405.7,405.07Z"
                fill="none"
                stroke="#fff"
                stroke-miterlimit="10"
                fillRule="evenodd"
              />
              <motion.path
                variants={pathVariants4}
                initial="hidden"
                animate="visible"
                d="M214.91,424.71q1,5,2,10l18.36-1.88h0"
                fill="none"
                stroke="#fff"
                stroke-miterlimit="10"
                fillRule="evenodd"
              />
              <motion.path
                variants={pathVariants4}
                initial="hidden"
                animate="visible"
                d="M350.74,121.73c.92-.25,2,.59,2.34,1.9s-.09,2.57-1,2.83-2-.58-2.34-1.89S349.82,122,350.74,121.73Z"
                fill="none"
                stroke="#fff"
                stroke-miterlimit="10"
                fillRule="evenodd"
              />
              <motion.path
                variants={pathVariants4}
                initial="hidden"
                animate="visible"
                d="M298.47,124.19c.92-.26,2,.59,2.34,1.9s-.09,2.57-1,2.83-2-.59-2.34-1.89S297.54,124.45,298.47,124.19Z"
                fill="none"
                stroke="#fff"
                stroke-miterlimit="10"
                fillRule="evenodd"
              />
              <motion.path
                variants={pathVariants4}
                initial="hidden"
                animate="visible"
                d="M383.34,149.23a.9.9,0,0,0,0-1.77.9.9,0,0,0,0,1.77Z"
                fill="none"
                stroke="#fff"
                stroke-miterlimit="10"
                fillRule="evenodd"
              />
              <motion.path
                variants={pathVariants4}
                initial="hidden"
                animate="visible"
                d="M389.63,145.92a.78.78,0,1,0-.71-.78A.75.75,0,0,0,389.63,145.92Z"
                fill="none"
                stroke="#fff"
                stroke-miterlimit="10"
                fillRule="evenodd"
              />
              <motion.path
                variants={pathVariants4}
                initial="hidden"
                animate="visible"
                d="M395.29,147.24a.67.67,0,1,0-.79-.66A.73.73,0,0,0,395.29,147.24Z"
                fill="none"
                stroke="#fff"
                stroke-miterlimit="10"
                fillRule="evenodd"
              />
              <motion.path
                variants={pathVariants4}
                initial="hidden"
                animate="visible"
                d="M386.51,142.26a.64.64,0,0,0,.62-.65.64.64,0,0,0-.62-.65.65.65,0,0,0-.63.65A.64.64,0,0,0,386.51,142.26Z"
                fill="none"
                stroke="#fff"
                stroke-miterlimit="10"
                fillRule="evenodd"
              />
              <motion.path
                variants={pathVariants4}
                initial="hidden"
                animate="visible"
                d="M372.44,145.59a.61.61,0,0,0,.61-.61.61.61,0,1,0-.61.61Z"
                fill="none"
                stroke="#fff"
                stroke-miterlimit="10"
                fillRule="evenodd"
              />
              <motion.path
                variants={pathVariants4}
                initial="hidden"
                animate="visible"
                d="M388.86,136.7a.61.61,0,1,0-.71-.61A.67.67,0,0,0,388.86,136.7Z"
                fill="none"
                stroke="#fff"
                stroke-miterlimit="10"
                fillRule="evenodd"
              />
              <motion.path
                variants={pathVariants4}
                initial="hidden"
                animate="visible"
                d="M392.23,140.23a.83.83,0,1,0-.88-.83A.85.85,0,0,0,392.23,140.23Z"
                fill="none"
                stroke="#fff"
                stroke-miterlimit="10"
                fillRule="evenodd"
              />
              <motion.path
                variants={pathVariants4}
                initial="hidden"
                animate="visible"
                d="M380.16,137.14a.59.59,0,1,0-.68-.58A.63.63,0,0,0,380.16,137.14Z"
                fill="none"
                stroke="#fff"
                stroke-miterlimit="10"
                fillRule="evenodd"
              />
              <motion.path
                variants={pathVariants4}
                initial="hidden"
                animate="visible"
                d="M384.31,137a.61.61,0,1,0-.61-.61A.61.61,0,0,0,384.31,137Z"
                fill="none"
                stroke="#fff"
                stroke-miterlimit="10"
                fillRule="evenodd"
              />
              <motion.path
                variants={pathVariants4}
                initial="hidden"
                animate="visible"
                d="M380.75,143.82a.72.72,0,0,0,0-1.44.72.72,0,0,0,0,1.44Z"
                fill="none"
                stroke="#fff"
                stroke-miterlimit="10"
                fillRule="evenodd"
              />
              <motion.path
                variants={pathVariants4}
                initial="hidden"
                animate="visible"
                d="M374.58,148.12a.45.45,0,0,0,.46-.44.46.46,0,0,0-.92,0A.45.45,0,0,0,374.58,148.12Z"
                fill="none"
                stroke="#fff"
                stroke-miterlimit="10"
                fillRule="evenodd"
              />
              <motion.path
                variants={pathVariants4}
                initial="hidden"
                animate="visible"
                d="M377,154.31c.31,0,.56-.4.56-.89s-.25-.88-.56-.88-.55.4-.55.88S376.69,154.31,377,154.31Z"
                fill="none"
                stroke="#fff"
                stroke-miterlimit="10"
                fillRule="evenodd"
              />
              <motion.path
                variants={pathVariants4}
                initial="hidden"
                animate="visible"
                d="M385.94,157a.69.69,0,1,0,0-1.36.69.69,0,1,0,0,1.36Z"
                fill="none"
                stroke="#fff"
                stroke-miterlimit="10"
                fillRule="evenodd"
              />
              <motion.path
                variants={pathVariants4}
                initial="hidden"
                animate="visible"
                d="M388.45,152a.55.55,0,0,0,.55-.55.55.55,0,0,0-.55-.55.54.54,0,0,0-.55.55A.55.55,0,0,0,388.45,152Z"
                fill="none"
                stroke="#fff"
                stroke-miterlimit="10"
                fillRule="evenodd"
              />
              <motion.path
                variants={pathVariants4}
                initial="hidden"
                animate="visible"
                d="M278.14,241.28c-.05-.26-.08-.55-.13-.89-.25-1.62,19.68-7.25,20.31-7.37s10.8.5,12,.95c4.41,1.66,15.38,14.45,23.53,23.84l71.05,57.9q2-7.5,4-15"
                fill="none"
                stroke="#fff"
                stroke-miterlimit="10"
                fillRule="evenodd"
              />
              <motion.path
                variants={pathVariants4}
                initial="hidden"
                animate="visible"
                d="M278.58,250.71c-.2-.73.26-1.56,1.78-2.37,4.1-2.19,21.05-7.05,21.05-7.05"
                fill="none"
                stroke="#fff"
                stroke-miterlimit="10"
                fillRule="evenodd"
              />
              <motion.path
                variants={pathVariants4}
                initial="hidden"
                animate="visible"
                d="M281.26,261.27c0-1.95,6.14-6,8.81-7.49,2.19-1.26,9.86-3.67,11.1-4.29l1.77-1.11"
                fill="none"
                stroke="#fff"
                stroke-miterlimit="10"
                fillRule="evenodd"
              />
              <motion.path
                variants={pathVariants4}
                initial="hidden"
                animate="visible"
                d="M433.91,300.71q-.51,7-1,14c-.09,5.28-.73,19.75-7,28a12.44,12.44,0,0,1-3.11,3c-6,3.9-14.2.9-18-.5-11.14-4.1-39.91-30.44-74.54-69h0s-4.86,1.29-12.11-2.34-9.86-7.12-9.86-7.12l-3.46-2a10.16,10.16,0,0,1-3.79,1.52s-4.9,6.28-7.83,4.28,1.82-6.78,1.82-6.78l6.75-4.94,4.95-2.58h0"
                fill="none"
                stroke="#fff"
                stroke-miterlimit="10"
                fillRule="evenodd"
              />
              <motion.path
                variants={pathVariants4}
                initial="hidden"
                animate="visible"
                d="M402.91,245.71c.25,8,.13,14.59,0,19,0,0-.3,9.25-2.81,36.35l36.25.25"
                fill="none"
                stroke="#fff"
                stroke-miterlimit="10"
                fillRule="evenodd"
              />
              <motion.path
                variants={pathVariants4}
                initial="hidden"
                animate="visible"
                d="M400.08,299.28c0,1.14,0,1.78,0,1.78l36.25.25c1.55-22.61,13.18-66.27,1.31-81.66l-2.75-2.94"
                fill="none"
                stroke="#fff"
                stroke-miterlimit="10"
                fillRule="evenodd"
                style={{ mixBlendMode: "multiply" }}
              />
              <motion.path
                variants={pathVariants4}
                initial="hidden"
                animate="visible"
                d="M231.06,407.14c1.7,11.44,4.21,25.69,4.21,25.69,2.78-.24,5.21-.6,6.42-.75,24.63-3.08,42.53-7.27,58.62-12.3,3.75-1.17,7.39-2.39,11-3.65,3.28-1.14,6.53-2.32,9.8-3.53l4.6-1.72,8.7-3.3,2.54-1c8.07-3.06,16.65-6.29,26.34-9.65,5.28-1.82,10.89-3.69,16.93-5.59q4.8-1.51,10-3.05s12-4.5,14.5-15c1.66-7,1.89-14.82-2.67-22.74-1,7.71-5.91,24.5-18.68,32.27-3.45,2.1-11,5-20.87,8.35-4,1.35-8.47,2.77-13.19,4.22-2.82.87-5.75,1.74-8.75,2.63l-.46.14c-2.87.84-5.81,1.69-8.79,2.53l-3,.85c-3.56,1-7.17,2-10.8,3-11.1,3-22.38,5.85-32.84,8.3-23.81,5.59-43.31,9.08-46.56,7.26C235.18,418.49,232.86,413.29,231.06,407.14Z"
                fill="none"
                stroke="#fff"
                stroke-miterlimit="10"
                fillRule="evenodd"
                style={{ mixBlendMode: "multiply" }}
              />
              <motion.path
                variants={pathVariants4}
                initial="hidden"
                animate="visible"
                d="M181.8,241.81c4.7.15,8.73,7.33,2.33,8.5s-8.64,1.07-11.14-1.43a5.44,5.44,0,0,1-1-5.33,5.55,5.55,0,0,1,.94-1.84"
                fill="none"
                stroke="#fff"
                stroke-miterlimit="10"
                fillRule="evenodd"
              />
              <motion.path
                variants={pathVariants4}
                initial="hidden"
                animate="visible"
                d="M184.36,242.58c3.3,1.91,4.95,6.79-.23,7.73-6,1.11-8.35,1.07-10.69-1"
                fill="none"
                stroke="#fff"
                stroke-miterlimit="10"
                fillRule="evenodd"
              />
              <motion.path
                variants={pathVariants4}
                initial="hidden"
                animate="visible"
                d="M184.73,250.38c4.71.14,8.74,7.32,2.34,8.5-4.5.82-6.93,1-8.85.19a5.16,5.16,0,0,1-2.29-1.63c-1.92-2.56-.2-6.36,0-6.73"
                fill="none"
                stroke="#fff"
                stroke-miterlimit="10"
                fillRule="evenodd"
              />
              <motion.path
                variants={pathVariants4}
                initial="hidden"
                animate="visible"
                d="M187.29,251.14c3.31,1.91,5,6.79-.23,7.74-6,1.1-8.35,1.07-10.69-1"
                fill="none"
                stroke="#fff"
                stroke-miterlimit="10"
                fillRule="evenodd"
              />
              <motion.path
                variants={pathVariants4}
                initial="hidden"
                animate="visible"
                d="M185.91,258.71c2.81,1.88,4.27,4,3.75,5.33-.28.72-1,1.25-2.44,1.52-5.15.94-6.95.85-9-1.16-1.51-1.51-.9-3.91-.82-4.29a5.65,5.65,0,0,1,.47-1.4"
                fill="none"
                stroke="#fff"
                stroke-miterlimit="10"
                fillRule="evenodd"
              />
              <motion.path
                variants={pathVariants4}
                initial="hidden"
                animate="visible"
                d="M187.4,259.34c2.66,1.54,4,5.45-.18,6.22-4.84.88-6.72.86-8.6-.82"
                fill="none"
                stroke="#fff"
                stroke-miterlimit="10"
                fillRule="evenodd"
              />
              <motion.polygon
                variants={pathVariants4}
                initial="hidden"
                animate="visible"
                points="263.26 289.77 298.05 281.35 299.61 287.51 264.81 295.93 263.26 289.77"
                fill="none"
                stroke="#fff"
                stroke-miterlimit="10"
                fillRule="evenodd"
              />
              <motion.path
                variants={pathVariants4}
                initial="hidden"
                animate="visible"
                d="M300.84,241.19a25,25,0,0,0-5.59-.15c-4.52.38-8.53,2.66-13.12,2.1-3.27-.4-3.79-.87-4-1.86"
                fill="none"
                stroke="#fff"
                stroke-miterlimit="10"
                fillRule="evenodd"
              />
              <motion.path
                variants={pathVariants4}
                initial="hidden"
                animate="visible"
                d="M302.94,248.38l-1.77,1.11s-5.3.32-8.28.9c-3.63.71-7.93,2.84-10.2,2.57-1.94-.24-3.81-1.13-4.11-2.25"
                fill="none"
                stroke="#fff"
                stroke-miterlimit="10"
                fillRule="evenodd"
              />
              <motion.path
                variants={pathVariants4}
                initial="hidden"
                animate="visible"
                d="M306.71,256.06c1.53.35-2.3,1.15-2.3,1.15h0c-.61,0-5.15.54-6.84.74-2,.24-6.1,2.64-8.05,3.48-2.76,1.18-5,2.24-7.82.5a.77.77,0,0,1-.43-.69"
                fill="none"
                stroke="#fff"
                stroke-miterlimit="10"
                fillRule="evenodd"
              />
              <motion.circle
                variants={pathVariants4}
                initial="hidden"
                animate="visible"
                cx="318.41"
                cy="141.21"
                r="2.5"
                fill="none"
                stroke="#fff"
                stroke-miterlimit="10"
              />
              <motion.path
                variants={pathVariants4}
                initial="hidden"
                animate="visible"
                d="M366.91,108.71a9.76,9.76,0,0,1,4,2c1.1.93,2.75,2.08,3,4a4.12,4.12,0,0,1,0,1"
                fill="none"
                stroke="#fff"
                stroke-miterlimit="10"
              />
              <motion.path
                variants={pathVariants4}
                initial="hidden"
                animate="visible"
                d="M212.91,208.71q12.5,50.49,25,101"
                fill="none"
                stroke="#fff"
                stroke-miterlimit="10"
              />
              <motion.path
                variants={pathVariants4}
                initial="hidden"
                animate="visible"
                d="M257.91,346.71c2.55-2.94,4.62-5.37,6-7,16.27-19.3,20.41-26.83,23-34,.47-1.32.81-2.4,1-3"
                fill="none"
                stroke="#fff"
                stroke-miterlimit="10"
                fillRule="evenodd"
              />
              <motion.path
                variants={pathVariants4}
                initial="hidden"
                animate="visible"
                d="M440.49,433.36a19.6,19.6,0,0,0,.94-19.8"
                fill="none"
                stroke="#fff"
                stroke-miterlimit="10"
                fillRule="evenodd"
              />
              <motion.path
                variants={pathVariants4}
                initial="hidden"
                animate="visible"
                d="M458.52,393.26H442.06v-1.33h82.7c4.86,0,8.84,2.28,8.84,5.08v8.48c0,2.8-4,5.08-8.84,5.08h-82.7v-1.33h16.46"
                fill="none"
                stroke="#fff"
                stroke-miterlimit="10"
                fillRule="evenodd"
              />
              <motion.path
                variants={pathVariants4}
                initial="hidden"
                animate="visible"
                d="M443.62,409.24H525c3.17,0,6.51-1.48,6.51-3.75V397c0-2.27-3.34-3.75-6.51-3.75H443.62a22.31,22.31,0,0,1,0,16Z"
                fill="none"
                stroke="#fff"
                stroke-miterlimit="10"
                fillRule="evenodd"
              />
              <motion.path
                variants={pathVariants4}
                initial="hidden"
                animate="visible"
                d="M492.69,409.26a22.31,22.31,0,0,0,0-16h-49a22.31,22.31,0,0,1,0,16Z"
                fill="none"
                stroke="#fff"
                stroke-miterlimit="10"
                fillRule="evenodd"
              />
              <motion.path
                variants={pathVariants4}
                initial="hidden"
                animate="visible"
                d="M533.91,435.71,435,435.28v-1.92l34.93.35"
                fill="none"
                stroke="#fff"
                stroke-miterlimit="10"
                fillRule="evenodd"
              />
              <motion.path
                variants={pathVariants4}
                initial="hidden"
                animate="visible"
                d="M469.91,413.71,435,413.56v-1.91l99.93.06"
                fill="none"
                stroke="#fff"
                stroke-miterlimit="10"
                fillRule="evenodd"
              />
              <motion.path
                variants={pathVariants4}
                initial="hidden"
                animate="visible"
                d="M470.18,411.65h63.09c8.89,0,8.89,23.63,0,23.63H470.18C477.56,431.26,477.07,416.6,470.18,411.65Z"
                fill="none"
                stroke="#fff"
                stroke-miterlimit="10"
                fillRule="evenodd"
              />
              <motion.path
                variants={pathVariants4}
                initial="hidden"
                animate="visible"
                d="M469.91,413.71a18.17,18.17,0,0,1,0,20"
                fill="none"
                stroke="#fff"
                stroke-miterlimit="10"
                fillRule="evenodd"
              />
              <motion.path
                variants={pathVariants4}
                initial="hidden"
                animate="visible"
                d="M2.91,399.71a23.32,23.32,0,0,1,5,12,24.07,24.07,0,0,1-5,17"
                fill="none"
                stroke="#fff"
                stroke-miterlimit="10"
                fillRule="evenodd"
              />
            </g>
          </g>
        </g>
      </svg>
    </div>
  );
};
